import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=51376f9b&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=ts&"
export * from "./NotificationCard.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotificationCard.vue?vue&type=style&index=1&id=51376f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51376f9b",
  null
  
)

/* custom blocks */
import block0 from "~/i18n/notifications.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3657449903%2Fsrc%2Fthreease_pro%2Fcomponents%2Ffeatures%2Fnotifications%2FNotificationCard.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseChip: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/Base/BaseChip.vue').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
